import { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import useClient from "../../hooks/useClient";

const ClientDashboardFilters = ({ filters, onChange }) => {
  const { clients, getClients } = useClient();
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    getClients();
  }, []);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
  const months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const handleYearChange = (e) => {
    const newFilters = { ...localFilters, year: e.target.value };
    setLocalFilters(newFilters);
    onChange(newFilters);
  };

  const handleMonthChange = (e) => {
    const newFilters = { ...localFilters, month: e.target.value };
    setLocalFilters(newFilters);
    onChange(newFilters);
  };

  const handleClientChange = (e) => {
    const newFilters = {
      ...localFilters,
      clientId: e.target.value || null,
    };
    setLocalFilters(newFilters);
    onChange(newFilters);
  };

  const handleStartDateChange = (e) => {
    const newFilters = { ...localFilters, startDate: e.target.value || null };
    setLocalFilters(newFilters);
    onChange(newFilters);
  };

  const handleEndDateChange = (e) => {
    const newFilters = { ...localFilters, endDate: e.target.value || null };
    setLocalFilters(newFilters);
    onChange(newFilters);
  };

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel>Year</InputLabel>
        <Select
          value={localFilters.year}
          onChange={handleYearChange}
          label="Year"
        >
          {years.map((year) => (
            <MenuItem
              key={year}
              value={year}
            >
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 150 }}>
        <InputLabel>Month</InputLabel>
        <Select
          value={localFilters.month}
          onChange={handleMonthChange}
          label="Month"
        >
          {months.map((month) => (
            <MenuItem
              key={month.value}
              value={month.value}
            >
              {month.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Start Date"
        type="date"
        value={localFilters.startDate || ""}
        onChange={handleStartDateChange}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{ minWidth: 180 }}
      />

      <TextField
        label="End Date"
        type="date"
        value={localFilters.endDate || ""}
        onChange={handleEndDateChange}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{ minWidth: 180 }}
      />

      <FormControl sx={{ minWidth: 250 }}>
        <InputLabel>Clients</InputLabel>
        <Select
          value={localFilters.clientId || ""}
          onChange={handleClientChange}
          label="Clients"
        >
          <MenuItem value="">
            <em>All Clients</em>
          </MenuItem>
          {clients?.map((client) => (
            <MenuItem
              key={client.id}
              value={client.id}
            >
              {client.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ClientDashboardFilters;
